<template>
  <div class="loadding-mask" v-if="loading">
    <img :src="defaultLoading" alt="loading" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import defaultLoading from '../../assets/images/common/loading.gif';

export default {
  name: 'loading',
  data() {
    return {
      defaultLoading
      // loading: ''
    };
  },
  props: ['loading'],
  computed: {
    ...mapGetters('global', ['config'])
  }
};
</script>
<style scoped lang="scss">
.loadding-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 220px;
    height: 220px;
  }
}
</style>
